import { memo, useContext } from 'react';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import Skeleton from '@mui/material/Skeleton';
import { AppThemingContext } from '@trinity/chat-components/containers/AppTheming/Context.js';
import { cx } from '@trinity/chat-components';
import styles from './style/Button.module.css';

type Props = {
  className?: string;
  count?: number;
  onClick: () => void;
};

export const ObjectAccessButton = memo(({ className, count, onClick }: Props) => {

  const { palette, theme: wl } = useContext(AppThemingContext);

  const counterStyle = wl?.enabled ? {
    backgroundColor: palette.primary.main,
    color: palette.primary.text,
  } : {};

  return (
    <div className={cx(styles.access, className)}>
      <div className={styles.bg}>
        <button
          className={styles.btn}
          onClick={onClick}>
          <GroupsOutlinedIcon className={styles.icon} />
          {count > 0 &&
            <div className={styles.counter} style={counterStyle}>{count}</div>}
        </button>
      </div>
    </div>
  );
});

export const SkeletonAccess = memo(() => {
  return (
    <Skeleton
      height={30}
      width={50}
      variant="rounded" />
  );
});